import styled from 'styled-components'

export const PlaceHolder = styled.span`
    height: 27px;
    width: 27px;
`
